import React, { Component } from "react";
import BaseModal, { ModalActions, SaveButton, CancelButton } from "../../../../containers/UI/Modal/BaseModal";
import SelectRow from "../../../configuration/Rows/SelectRow/SelectRow";
import InputRow from "../../../configuration/Rows/InputRow/InputRow";
import classes from "./GatewayModal.css"
import axios from "../../../../axios";


class GatewayModal extends Component {

  state = {
    createMode: false
  }

  pcieOptions = [{ label: "None", value: "None"}, { label: "N-Fuse SX1301", value: "N-Fuse SX1301"}, { label: "Seeed WM1302", value: "Seeed WM1302"}, { label: "N-Fuse SX1308", value: "N-Fuse SX1308"}, { label: "RAK SX1302", value: "RAK SX1302"}]
  modelOptions = [
    { label: "Seeed R1013", value: "r1013-10"},
    { label: "Allorado Box", value: "cm4-board-rev1.0" },
    { label: "IOT2050 Advanced FS:09", value: "fs09"},
    { label: "IOT2050 Advanced FS:08", value: "fs08"},
    { label: "IOT2050 Advanced FS:07", value: "fs07"},
    { label: "IOT2050 Advanced FS:05", value: "fs05"},
    { label: "IOT2050 Advanced FS:04", value: "fs04"},
    { label: "IOT2050 Advanced FS:02", value: "fs02"},
    { label: "IOT2050 Basic", value: "fs03"},
    { label: "Seeed R1025", value: "r1025-10"},
    { label: "Seeed R1024", value: "r1024-10"},
    { label: "Evolution", value: "evolution" },
  ]


  componentDidMount() {
    this.setState({ ...this.props.selectedGateway, createMode: this.props.createMode })
  }


  // MARK: - CRUD handlers

  saveGatewayToServer = () => {

    // Implement validators
    if (!this.state.model) {
      alert("Please select a platform.")
      return
    }
    if (!this.state.serialNumber) {
      alert("Please enter a serial number.")
      return
    }
    if (!this.state.cpuUUID) {
      alert("Please enter a UUID.")
      return
    }
    if (!this.state.customer) {
      alert("Please select a customer.")
      return
    }
    if (!this.state.trivialName) {
      alert("Please enter a friendly name.")
      return
    }

    // In create mode, increment the fleet counter
    if (this.props.createMode) {
      let customerOption = this.props.customers.find(obj => obj.value === this.state.customer)
      if (customerOption && customerOption.fleetCount) {
        customerOption.fleetCount = customerOption.fleetCount + 1
      }
    }

    // Sync to the backend
    axios.post("/fleet/update", this.state);
    // Close the modal view
    this.props.closeModal()
  }

  cancelEditHandler = () => {
    this.props.closeModal()
  }


  // MARK: - Import handlers

  uploadRequestFile = (event, thisRef) => {

    // Prepare reader
    var reader = new FileReader()

    // Handle content
    reader.onload = () => {
      // Try parsing as JSON
      let importfile = {}
      try {
        importfile = JSON.parse(reader.result)
      } catch (e) {
        return
      }

      // Process data from license request
      this.processLicenseRequest(importfile, thisRef)
    }

    // Read data
    reader.readAsText(event.target.files[0], "utf8")
  }

  processLicenseRequest = (file, thisRef) => {

    if (file.contentType === "hardware-metadata") {
      
      // Handle format 1 - starting in software 1.6
      if (file.formatVersion === 1) {

        // Model conversion
        let modelConversion = {
          "Seeed R1000": "r1013-10",
          "Siemens IOT2050": "fs09"
        }
        let expansionConversion = {
          "Seeed R1000": "Seeed WM1302",
          "Siemens IOT2050": "N-Fuse SX1308"
        }

        // Temporary hack for increased efficiency
        // Until 1.8.0, serial === UUID for Seeed
        let versionNumber = file.software
        if (!versionNumber) {
          if (file.uuid === file.serialNumber) {
            versionNumber = "1.7.1"
          }
        }

        thisRef.setState({
          cpuUUID: file.uuid,
          serialNumber: file.serialNumber,
          model: modelConversion[file.model],
          pcieExpansion: expansionConversion[file.model],
          versionNumber: versionNumber,
          tpmPubKey: file.tpmPubKey
        })
      }
    }
  }

  
  // MARK: - Edit handlers

  selectCustomerHandler = (selected) => {

    let name = this.state.trivialName
    
    // In create mode, generate a name automatically
    if (this.state.createMode) {
      name = selected.shortName + " no. " + (selected.fleetCount + 1)
    }

    this.setState({
      customer: selected.value,
      trivialName: name
    })
  }


  render() {

    // Extract deals
    let dealOptions = (this.state.customer in this.props.deals) ? this.props.deals[this.state.customer] : []

    return (
      <BaseModal 
        isOpen={this.props.shouldShow} 
        onClose={this.cancelEditHandler}
      >
        <div className={classes.titleRow}>
          <h3 className={classes.title}>{ this.state.createMode ? "Add new" : "Edit"} gateway</h3>
          <input type="file" id="fileInput" accept={".json"} className={classes.importInput} onChange={(e) => this.uploadRequestFile(e, this)}/>
          <label htmlFor="fileInput" className={classes.importButton}>Upload .json file</label>
        </div>
        <SelectRow
          title="Platform"
          ultrawide
          firstRow
          value={this.state.model ?? ""}
          onChange={(newValue) => this.setState({ model: newValue.value })}
          options={this.modelOptions}/>
        <SelectRow
          title="Expansion slot"
          ultrawide
          value={this.state.pcieExpansion ?? ""}
          onChange={(newValue) => this.setState({ pcieExpansion: newValue.value })}
          options={this.pcieOptions}/>
        <InputRow
          title="Serial number"
          ultrawide
          enabled={this.state.licensed !== true}
          value={this.state.serialNumber ?? ""}
          placeholder={"Serial number"}
          onChange={(event) => this.setState({ serialNumber: event.target.value.toUpperCase() })}/>
        <InputRow
          title="UUID"
          ultrawide
          enabled={this.state.licensed !== true}
          value={this.state.cpuUUID ?? ""}
          placeholder={"UUID"}
          onChange={(event) => this.setState({ cpuUUID: event.target.value.toUpperCase() })}/>
        <InputRow
          title="TPM public key"
          ultrawide
          enabled={this.state.licensed !== true}
          value={this.state.tpmPubKey ?? ""}
          placeholder={(this.state.licensed !== true) ? "TPM public key (optional)" : "No public key registered"}
          onChange={(event) => this.setState({ tpmPubKey: event.target.value })}/>
        <InputRow
          title="Software version"
          enabled
          ultrawide
          value={this.state.versionNumber ?? ""}
          placeholder={"E.g. 1.1.4"}
          onChange={(event) => this.setState({ versionNumber: event.target.value })}/>

        <hr style={{ margin: "10px 0 15px 0", border: "0.7px solid #ff6315"}}/>

        <SelectRow
          title="Customer"
          ultrawide
          firstRow
          value={this.state.customer ?? ""}
          onChange={this.selectCustomerHandler}
          options={this.props.customers}/>
        { dealOptions.length > 0 &&
        <SelectRow
          title="Part of deal"
          ultrawide
          value={this.state.deal ?? ""}
          onChange={(newValue) => this.setState({ deal:  newValue.value })}
          options={dealOptions}/>
        }
        <InputRow
          title="Friendly name"
          enabled
          ultrawide
          value={this.state.trivialName ?? ""}
          placeholder={"E.g. Bacbee no. 24"}
          onChange={(event) => this.setState({ trivialName: event.target.value })}/>

        <ModalActions>
          <CancelButton onClick={this.cancelEditHandler}/>
          <SaveButton onClick={this.saveGatewayToServer}/>
        </ModalActions>
      </BaseModal>
    );
  }

  // MARK: - Date format helper
  formatDate = (epoch) => {
    // Create date
    var date = new Date(0)
    date.setUTCSeconds(epoch)
    // Format properly
    return date.toLocaleDateString("en-us", { year: "numeric", month: "long", day: "numeric"})
  }
}

export default GatewayModal;
